// extracted by mini-css-extract-plugin
module.exports = {"section-wrapper":"MyCourses_section-wrapper__2ZT6h"};